import { createAction, props, union } from '@ngrx/store';

export const openTopUpDialog = createAction(
  '[@zerops/zerops/feature/top-up-dialog] open'
);

// Cross-flow handoff: a PAYMENT-mode code typed into the standalone promo
// section arrives here with the code already in hand, so the user doesn't
// retype it. The reverse direction (a standalone code typed into a top-up)
// hands back the other way.
export const openTopUpDialogWithPromoCode = createAction(
  '[@zerops/zerops/feature/top-up-dialog] open-with-promo-code',
  props<{ promoCode: string; }>()
);

const all = union({
  openTopUpDialog,
  openTopUpDialogWithPromoCode
});

export type TopUpDialogActionUnion = typeof all;
